import { useStorage } from '@vueuse/core'

export default defineNuxtPlugin({
    enforce: 'post',
    async setup({ $bus }) {
        $bus.$on(
            'wishlistAddProductsSuccess',
            ({
                data: {
                    wishlist: { itemCount },
                },
            }) => {
                const event = new CustomEvent('WISHLIST_PRODUCT_ADD', {
                    detail: {
                        item_count: itemCount,
                    },
                })
                window.dispatchEvent(event)
                useStorage('mage-cache-storage-section-invalidation', { wishlist: true }, localStorage, {
                    mergeDefaults: true,
                })
            },
        )

        $bus.$on('updateMagentoMiniCart', ({ cartItems, subtotal }) => {
            processMagentoLocalStorageAndTriggerEvent(cartItems, subtotal)
        })

        $bus.$on('addToCartSuccess', ({ cartItems, subtotal }) => {
            processMagentoLocalStorageAndTriggerEvent(cartItems, subtotal)
        })

        function processMagentoLocalStorageAndTriggerEvent(cartItems, subtotal) {
            const summary_count = cartItems.reduce((sum: number, { qty }: { qty: number }) => sum + qty, 0)

            const event = new CustomEvent('CUSTOMER_DATA_CART_CHANGE', {
                detail: {
                    cart: {
                        items: cartItems,
                        subtotal,
                        summary_count,
                    },
                },
            })
            window.dispatchEvent(event)
            const mageCacheStorage = JSON.parse(localStorage.getItem('mage-cache-storage'))
            const newMageCacheStorage = {
                ...mageCacheStorage,
                ...{
                    cart: {
                        items: cartItems,
                        subtotal,
                        summary_count,
                    },
                },
            }
            localStorage.setItem('mage-cache-storage', JSON.stringify(newMageCacheStorage))
            useStorage('mage-cache-storage-section-invalidation', { cart: true }, localStorage, { mergeDefaults: true })
        }
    },
})
